import { render, staticRenderFns } from "./my_buy.vue?vue&type=template&id=4ba341df&scoped=true&"
import script from "./my_buy.vue?vue&type=script&lang=js&"
export * from "./my_buy.vue?vue&type=script&lang=js&"
import style0 from "./my_buy.vue?vue&type=style&index=0&id=4ba341df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba341df",
  null
  
)

export default component.exports